export default "__VITE_ASSET__BfVshQrH__"